(function () {
  'use strict';

  const MATERIAL_OPTION = 'Material';
  const FRAME_COLOR_OPTION = 'Frame Color';
  const FRAMED_MATERIAL = 'Canvas Framed';
  const HIDDEN_FRAME_COLOR = 'NA';
  const DEFAULT_FRAME_COLOR = 'Black';
  const FRAME_COLOR_GROUP_CLASS = 'custom-frame-color-group';
  const HIDDEN_OPTION_CLASS = 'custom-hidden-option';
  const STYLE_ID = 'custom-frame-color-styles';

  const normalize = (value) => String(value || '').trim().toLowerCase();

  function getOptionName(control) {
    // Denim's Liquid capture adds a trailing newline to radio names.
    const name = (control.getAttribute('name') || '').trim();
    const dropdownMatch = name.match(/^options\[(.*)]$/);

    if (dropdownMatch) return dropdownMatch[1];

    // Denim adds the option position to radio names, for example "Material-1".
    return name.replace(/-\d+$/, '');
  }

  function getOptionGroup(picker, optionName) {
    return Array.from(picker.querySelectorAll('.product-form__input')).find((group) =>
      Array.from(group.querySelectorAll('input[type="radio"], select')).some(
        (control) => normalize(getOptionName(control)) === normalize(optionName)
      )
    );
  }

  function getOptionControls(group, optionName) {
    if (!group) return [];

    return Array.from(group.querySelectorAll('input[type="radio"], select')).filter(
      (control) => normalize(getOptionName(control)) === normalize(optionName)
    );
  }

  function getSelectedValue(controls) {
    const select = controls.find((control) => control.tagName === 'SELECT');
    if (select) return select.value;

    return controls.find((control) => control.checked)?.value || '';
  }

  function selectValue(controls, value) {
    const targetValue = normalize(value);
    const select = controls.find((control) => control.tagName === 'SELECT');

    if (select) {
      const option = Array.from(select.options).find(
        (item) => normalize(item.value) === targetValue
      );

      if (!option || select.value === option.value) return;

      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const input = controls.find((control) => normalize(control.value) === targetValue);
    if (!input || input.checked) return;

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function hideNAChoice(frameColorControls) {
    frameColorControls.forEach((control) => {
      if (control.tagName === 'SELECT') {
        const option = Array.from(control.options).find(
          (item) => normalize(item.value) === normalize(HIDDEN_FRAME_COLOR)
        );
        if (option) {
          option.hidden = true;
          option.classList.add(HIDDEN_OPTION_CLASS);
        }
        return;
      }

      if (normalize(control.value) !== normalize(HIDDEN_FRAME_COLOR)) return;

      control.classList.add(HIDDEN_OPTION_CLASS);
      Array.from(control.labels || []).forEach((label) => {
        label.hidden = true;
        label.classList.add(HIDDEN_OPTION_CLASS);
      });
    });
  }

  function updatePicker(picker, defaultToBlack) {
    const materialGroup = getOptionGroup(picker, MATERIAL_OPTION);
    const frameColorGroup = getOptionGroup(picker, FRAME_COLOR_OPTION);
    if (!materialGroup || !frameColorGroup) return;

    const materialControls = getOptionControls(materialGroup, MATERIAL_OPTION);
    const frameColorControls = getOptionControls(frameColorGroup, FRAME_COLOR_OPTION);
    if (!materialControls.length || !frameColorControls.length) return;

    frameColorGroup.classList.add(FRAME_COLOR_GROUP_CLASS);
    hideNAChoice(frameColorControls);

    const isCanvasFramed =
      normalize(getSelectedValue(materialControls)) === normalize(FRAMED_MATERIAL);

    frameColorGroup.hidden = !isCanvasFramed;

    if (!isCanvasFramed) {
      selectValue(frameColorControls, HIDDEN_FRAME_COLOR);
      return;
    }

    const selectedFrameColor = getSelectedValue(frameColorControls);
    if (defaultToBlack || normalize(selectedFrameColor) === normalize(HIDDEN_FRAME_COLOR)) {
      selectValue(frameColorControls, DEFAULT_FRAME_COLOR);
    }
  }

  function initializePickers(root) {
    if (root instanceof Element && root.matches('variant-selects')) {
      updatePicker(root, false);
    }

    if (root instanceof Element) {
      const parentPicker = root.closest('variant-selects');
      if (parentPicker) updatePicker(parentPicker, false);
    }

    root.querySelectorAll?.('variant-selects').forEach((picker) => updatePicker(picker, false));
  }

  document.addEventListener('change', (event) => {
    const control = event.target.closest?.('input[type="radio"], select');
    const picker = control?.closest('variant-selects');

    if (!picker || normalize(getOptionName(control)) !== normalize(MATERIAL_OPTION)) return;

    updatePicker(picker, true);
  });

  document.addEventListener('shopify:section:load', (event) => initializePickers(event.target));

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) initializePickers(node);
      });
    });
  });

  function initialize() {
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = `
        .${FRAME_COLOR_GROUP_CLASS} .${HIDDEN_OPTION_CLASS},
        .${FRAME_COLOR_GROUP_CLASS} input[value="${HIDDEN_FRAME_COLOR}"] + label {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }

    initializePickers(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
